import React, {
  useEffect,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from "react";
import RadioButtonGroup from "../../components/common/ui/Inputs/RadioInput";
import { useDispatch, useSelector } from "react-redux";
import {
  managementUserAction,
  facilityAction,
  authActions,
  inmateAction,
} from "../../_store";
import { CheckBoxInput } from "../../components/common/ui/Inputs";
import Table from "../../components/common/table/Table";
import "../../assets/css/CommonStyle.css";
import CustomLoader from "../../components/common/ui/Loader";

const FacilityAdminMenuAccess = forwardRef((props, ref) => {
  const { AccessPermissionRadio } = useSelector((x) => x.dropdownOptions);
  const {
    PostalMailGrid,
    managementUserData,
    menu: menuList,
    UserAccessibleRequestForm: RequestForm,
    // managementUserInfo,
  } = useSelector((state) => state.managementUser);

  const {
    user,
    commonFacilityCode: FacilityID,
    userAccessibleMenuInfo,
  } = useSelector((x) => x.auth); // Get current authenticated user
  const { facilityInfodata } = useSelector((x) => x.inmate);
  // const { commonFacilityCode: FacilityID } = useSelector(
  //   (state) => state.master
  // ); // Facility ID (commonFacilityCode) from master state

  const dispatch = useDispatch();

  useImperativeHandle(ref, () => ({
    UpdateMenulist,
    ResetPostMailList,
  }));
  const [isLoading, setisLoading] = React.useState(true);

  const userInfo = { ...managementUserData };

  useEffect(() => {
    if (FacilityID) {
      const ManagementUserID = managementUserData?.ManagementUserID || 0;

      dispatch(
        managementUserAction.LoadPostalMailAccessibleFacility({
          ManagementUserID,
          FacilityID,
        })
      );

      dispatch(
        managementUserAction.LoadUserAccessibleRequestForm({
          ManagementUserID,
          FacilityID,
        })
      );
      if (ManagementUserID == 0) { setisLoading(false); return; }
      setisLoading(true);
      dispatch(
        inmateAction.GetFacilityInfo(FacilityID)
      ).then(() => setisLoading(false));
      if (managementUserData?.ManagementUserID > 0) {
        dispatch(
          authActions.GetUserAccessibleMenuInfo(
            managementUserData?.ManagementUserID
          )
        );
      }
    }
  }, [dispatch, FacilityID, managementUserData?.ManagementUserID]);

  //

  // Set user information once data dependencies are available
  useEffect(() => {
    if (PostalMailGrid && RequestForm) {
      const params = {
        ...userInfo,
        type_PostalMailAccessibleFacility: PostalMailGrid.map((facility) => ({
          mangementUserID: managementUserData?.ManagementUserID,
          facilityID: facility.FacilityID || 0,
          isActive: facility.IsActive || 0,
        })),
        type_ManagementUserRequestFormPermission: RequestForm.map((data) => ({
          RequestFormTypeID: data.RequestFormTypeID,
          RFPermissionID: data.RFPermissionID || 0,
          FacilityID: FacilityID || 0,
          ActiveStatus: data.ActiveStatus || 0,
          FormView: data.FormView || 0,
          FormRespond: data.FormRespond || 0,
        })),
      };

      // Dispatch to set management user data only after data dependencies are ready
      dispatch(managementUserAction.setmanagementUserData(params));
    }
  }, [dispatch, PostalMailGrid, RequestForm]);

  useEffect(() => {
    if (
      userAccessibleMenuInfo.length > 0 &&
      managementUserData?.ManagementUserID > 0
    ) {
      userInfo.type_ManagementUserMenuPermission = userAccessibleMenuInfo;
      dispatch(managementUserAction.setmanagementUserData(userInfo));
      UpdateMenulist();
    }
  }, [userAccessibleMenuInfo]);

  const UpdateMenulist = () => {
    let updatedMenuList = [...menuList];
    userAccessibleMenuInfo.forEach((menu) => {
      updatedMenuList = updatedMenuList.map((menulist) => {
        if (menulist.ManagementMenuID === menu.ManagementMenuID) {
          if (menu.SubManagementMenuID !== 0 && menulist.subMenu) {
            return {
              ...menulist,
              MenuActiveStatus: parseInt(menu?.MenuActiveStatus),
              subMenu: menulist.subMenu.map((subMenuItem) => {
                if (
                  subMenuItem.SubManagementMenuID === menu.SubManagementMenuID
                ) {
                  return {
                    ...subMenuItem,
                    SubMenuActiveStatus: parseInt(menu?.SubMenuActiveStatus), // Update SubMenuActiveStatus
                  };
                }
                return subMenuItem;
              }),
            };
          }
          // Update the MenuActiveStatus for the main menu item
          return {
            ...menulist,
            MenuActiveStatus: parseInt(menu?.MenuActiveStatus), // Update the main menu status
          };
        }
        return menulist;
      });
    });
    dispatch(managementUserAction.updatemenuList(updatedMenuList));
  };

  const ResetPostMailList = () => {
    const ManagementUserID = managementUserData?.ManagementUserID || 0;
    dispatch(
      managementUserAction.LoadPostalMailAccessibleFacility({
        ManagementUserID,
        FacilityID,
      })
    );
  };

  const filteredMenuList = useMemo(
    () =>
      menuList?.filter((menu) => {
        if (menu.isActive !== 1) return false;

        const allowedRoles = {
          "Management Users": [12],
          Dashboard: [2, 3, 12, 13],
          Documents: [2, 12],
          "Postal Mails": [2, 3, 6, 12, 13],
          Lockdown: [2, 12],
          Inmates: [2, 6, 12, 13],
          "Public Users": [2, 6, 12],
          "Staff Requests": [2, 3, 6, 12, 13],
          Messages: [2, 3, 6, 12, 13],
          Photos: [2, 3, 6, 12, 13],
          Keywords: [2, 6, 12],
          Notices: [2, 3, 12, 13],
          "Connection Requests": [2, 3, 6, 12, 13],
          Reporting: [2, 12],
        };

        return allowedRoles[menu.MenuName]?.includes(
          managementUserData.UserRoleID
        );
      }),
    [menuList, managementUserData.UserRoleID]
  );

  const UpdatePostMailList = () => {
    let UpdatedPostMail = [...PostalMailGrid];

    if (UpdatedPostMail.length > 0) {
      UpdatedPostMail = UpdatedPostMail.map((postmail) => {
        return {
          ...postmail,
          IsActive: 0,
        };
      });
      dispatch(managementUserAction.setPostalMailGrid(UpdatedPostMail));
    }
  };

  // Handle changes to the radio buttons (menu enable/disable)
  const handleSelectMenuChange = (value, menuName, menuID) => {
    // Update `menuList` to reflect the new active status for the selected menu
    let updatedMenuList = menuList.map((menu) => {
      // Check if the current menu item matches `menuName`; if so, update `MenuActiveStatus`
      if (menu.MenuName === menuName) {
        if (
          menu?.subMenu &&
          menu?.ManagementMenuID === menuID &&
          parseInt(value) === 1
        ) {
          return {
            ...menu, // Spread existing properties
            MenuActiveStatus: parseInt(value),
            subMenu: menu.subMenu?.map((subMenus) => {
              return {
                ...subMenus, // Spread the properties of the subMenu item
                SubMenuActiveStatus:
                  subMenus?.SubMenuName !== "Legal Mail"
                    ? menu.MenuName === "Connection Requests"
                      ? 0
                      : 1
                    : parseInt(subMenus?.SubMenuActiveStatus), // Set the SubMenuActiveStatus
              };
            }),
          };
        }
        return {
          ...menu, // Spread existing properties
          MenuActiveStatus: parseInt(value), // Update `MenuActiveStatus` with the new value from the radio button
        };
      }
      return {
        ...menu, // Spread existing properties
        MenuActiveStatus:
          menu.MenuActiveStatus !== 0 && menu.MenuActiveStatus !== 1
            ? 0
            : menu.MenuActiveStatus, // Update `MenuActiveStatus` with the new value from the radio button
      };
    });

    if (menuName === "Postal Mail" && parseInt(value) === 1) {
      UpdatePostMailList();
    }

    // Dispatch the updated menu list to the Redux store
    dispatch(managementUserAction.updatemenuList(updatedMenuList));

    // Generate a permissions array based on the filtered menu list
    const permissions = updatedMenuList
      .map((menu) => {
        // Main permission object for the menu item
        const mainPermission = {
          managementMenuID: menu.ManagementMenuID,
          // If this menu matches the selected `menuID`, update `menuActiveStatus` with the new value
          menuActiveStatus:
            menu.ManagementMenuID === menuID
              ? parseInt(value)
              : menu.MenuActiveStatus,
          subManagementMenuID: menu.SubManagementMenuID || 0,
          subMenuActiveStatus: menu.SubMenuActiveStatus || 0,
        };

        // Generate permission objects for submenus, if any
        const subMenuPermissions =
          // Generate submenu permissions only if:
          // 1. The menu is the selected one (`menuID`) and is enabled (`value` is 1).
          // 2. Or, if it’s a different menu (not the selected `menuID`), so it remains unaffected.
          // Ensure `menu.subMenu` is an array before mapping submenus.
          ((menu.ManagementMenuID === menuID && value === 1) ||
            menu.ManagementMenuID !== menuID) &&
            Array.isArray(menu.subMenu)
            ? menu.subMenu.map((subMenu) => ({
              managementMenuID: menu.ManagementMenuID,
              menuActiveStatus: menu.MenuActiveStatus,
              subManagementMenuID: subMenu.SubManagementMenuID,
              subMenuActiveStatus: subMenu.SubMenuActiveStatus || 0,
            }))
            : [];
        // Combine main permission and submenu permissions into a single array for each menu item
        return [mainPermission, ...subMenuPermissions];
      })
      .flat(); // Flatten nested arrays to get a single-level array of permission objects

    // Update the `type_ManagementUserMenuPermission` in `userInfo` with the new permissions
    userInfo.type_ManagementUserMenuPermission = permissions;

    // Dispatch the updated `userInfo` to Redux to reflect the changes
    dispatch(managementUserAction.setmanagementUserData(userInfo));
  };

  // Handle changes to the checkboxes (subfields)
  const handleCheckboxChange = (value, subFieldName, menuId, subMenuId) => {
    let updatedMenuList = menuList.map((menu) => {
      // Check if the menu's ManagementMenuID matches the provided menuId
      if (menu.ManagementMenuID === menuId) {
        // Check if the menu has a subMenu array
        let updatedSubMenu = menu.subMenu?.map((submenu) => {
          // Check if the submenu name matches the subFieldName
          if (submenu.SubMenuName === subFieldName) {
            return {
              ...submenu,
              SubMenuActiveStatus: value ? 1 : 0, // Update based on checkbox state
            };
          }
          return submenu; // Return unchanged submenu if it doesn't match
        });

        // Return the updated menu with the updated subMenu
        return {
          ...menu,
          subMenu: updatedSubMenu, // Replace the old subMenu with the updated one
        };
      }
      return menu; // Return unchanged menu if ManagementMenuID doesn't match
    });

    // Dispatch the updated menu list
    dispatch(managementUserAction.updatemenuList(updatedMenuList));

    // Generate a permissions array based on the filtered menu list
    const permissions = updatedMenuList
      .map((menu) => {
        // Main permission object for the menu item
        const mainPermission = {
          managementMenuID: menu.ManagementMenuID,
          menuActiveStatus: menu.MenuActiveStatus,
          subManagementMenuID: menu.SubManagementMenuID || 0,
          subMenuActiveStatus: menu.SubMenuActiveStatus || 0,
        };

        // Generate permission objects for submenus, if any
        const subMenuPermissions = (menu.subMenu || []).map((subMenu) => ({
          managementMenuID: menu.ManagementMenuID,
          menuActiveStatus: menu.MenuActiveStatus,
          subManagementMenuID: subMenu.SubManagementMenuID,
          subMenuActiveStatus:
            (subMenu.SubManagementMenuID === subMenuId && menuId == subMenu?.managementMenuID)
              ? value
                ? 1
                : 0
              : subMenu.SubMenuActiveStatus || 0,
        }));

        // Combine main permission and submenu permissions into a single array for each menu item
        return [mainPermission, ...subMenuPermissions];
      })
      .flat(); // Flatten nested arrays to get a single-level array of permission objects

    // Update the `type_ManagementUserMenuPermission` in `userInfo` with the new permissions
    userInfo.type_ManagementUserMenuPermission = permissions;

    // Dispatch the updated `userInfo` to Redux to reflect the changes
    dispatch(managementUserAction.setmanagementUserData(userInfo));
  };

  const columns = [
    {
      width: "50px",
      selector: (row, index) => (
        <CheckBoxInput
          // Individual row checkboxes
          checked={row?.IsActive === 1 ? true : false}
          value={row?.IsActive}
          handleClick={
            (e) => handleClickPostalMail(row.FacilityID, e.target.checked) // Use checked instead of value
          }
        />
      ),
      center: true,
    },
    {
      name: "Facility Code",
      selector: (row) => row.FacilityCode,
      sortable: true,
      cell: (row) => (
        <div
          onClick={() =>
            handleClickPostalMail(row.FacilityID, row?.IsActive === 1 ? 0 : 1)
          }
        >
          {row.FacilityCode}
        </div>
      ),
    },
    {
      name: "Facility Name",
      selector: (row) => row.FacilityName,
      sortable: true,
      cell: (row) => (
        <div
          onClick={() =>
            handleClickPostalMail(row.FacilityID, row?.IsActive === 1 ? 0 : 1)
          }
        >
          {row.FacilityName}
        </div>
      ),
    },
  ];

  const RFcolumns = [
    {
      width: "50px",
      selector: (row, index) => (
        <div style={{ padding: "0px" }}>
          <CheckBoxInput
            checked={row?.ActiveStatus === 1}
            value={row?.ActiveStatus}
            handleClick={(e) => handleClickFormView(row, e.target.checked)}
          />
        </div>
      ),
    },
    {
      name: "Type",
      selector: (row) => row.RequestFormType,
      // sortable: true,
      cell: (row) => (
        <div
          style={{ padding: "0px" }}
          onClick={() =>
            handleClickFormView(row, row?.ActiveStatus === 1 ? 0 : 1)
          }
        >
          {row.FacilityRequestFormTitle}
        </div>
      ),
    },
    {
      width: "250px",
      name: "Actions",
      selector: (row) => (
        <div
          className="gap-3-5"
          style={{ display: "flex", gap: "0px", padding: "0px" }}
        >
          <CheckBoxInput
            label="View"
            checked={row?.FormView === 1}
            value={row?.FormView}
            handleClick={(e) =>
              handleClickFormAction(row, e.target.checked, "View")
            }
            labelClick={() =>
              handleClickFormAction(row, row?.FormView === 1 ? 0 : 1, "View")
            }
          />
          <CheckBoxInput
            label="Respond"
            checked={row?.FormRespond === 1}
            value={row?.FormRespond}
            handleClick={(e) =>
              handleClickFormAction(row, e.target.checked, "Respond")
            }
            labelClick={() =>
              handleClickFormAction(
                row,
                row?.FormRespond === 1 ? 0 : 1,
                "Respond"
              )
            }
          />
        </div>
      ),
    },
  ];

  const handleClickFormAction = (row, checked, action) => {
    const updatedRequestForm = RequestForm.map((data) => {
      if (data.RFPermissionID === row.RFPermissionID) {
        return {
          ...data, // Spread existing data properties
          //  ActiveStatus: checked ? 1 : 0, // Update ActiveStatus based on the checkbox state
          FormView:
            row.ActiveStatus && action === "View"
              ? checked
                ? 1
                : 0
              : row.FormView,
          FormRespond:
            row.ActiveStatus && action === "Respond"
              ? checked
                ? 1
                : 0
              : row.FormRespond,
        };
      }
      return {
        ...data, // Return the original data object for non-matching items
      };
    });

    dispatch(managementUserAction.setRequestForm(updatedRequestForm));

    const params = {
      ...userInfo,
      type_ManagementUserRequestFormPermission: RequestForm.map((data) => {
        // If the RFPermissionID matches, update the specific fields
        if (data.RFPermissionID === row.RFPermissionID) {
          return {
            RequestFormTypeID: data.RequestFormTypeID,
            RFPermissionID: data.RFPermissionID || 0,
            FacilityID: FacilityID || 0,
            ActiveStatus: data.ActiveStatus || 0,
            FormView:
              row.ActiveStatus && action === "View"
                ? checked
                  ? 1
                  : 0
                : row.FormView,
            FormRespond:
              row.ActiveStatus && action === "Respond"
                ? checked
                  ? 1
                  : 0
                : row.FormRespond,
          };
        }
        // For unmatched items, only return necessary fields without adding extra ones
        return {
          RequestFormTypeID: data.RequestFormTypeID,
          RFPermissionID: data.RFPermissionID || 0,
          FacilityID: FacilityID || 0,
          ActiveStatus: data.ActiveStatus || 0,
          FormView: data.FormView || 0,
          FormRespond: data.FormRespond || 0,
        };
      }),
    };
    dispatch(managementUserAction.setmanagementUserData(params));
  };

  const handleClickFormView = (row, checked) => {
    const updatedRequestForm = RequestForm.map((data) => {
      if (data.RFPermissionID === row.RFPermissionID) {
        return {
          ...data, // Spread existing data properties
          ActiveStatus: checked ? 1 : 0, // Update ActiveStatus based on the checkbox state
          FormView: checked ? 1 : 0,
          FormRespond: checked ? 1 : 0,
        };
      }
      return {
        ...data, // Return the original data object for non-matching items
      };
    });

    dispatch(managementUserAction.setRequestForm(updatedRequestForm));

    const params = {
      ...userInfo,
      type_ManagementUserRequestFormPermission: RequestForm.map((data) => {
        // If the RFPermissionID matches, update the specific fields
        if (data.RFPermissionID === row.RFPermissionID) {
          return {
            RequestFormTypeID: row.RequestFormTypeID,
            RFPermissionID: row.RFPermissionID || 0,
            FacilityID: row.FacilityID || 0,
            ActiveStatus: checked ? 1 : 0,
            FormView: checked ? 1 : 0,
            FormRespond: checked ? 1 : 0,
          };
        }
        // For unmatched items, only return necessary fields without adding extra ones
        return {
          RequestFormTypeID: data.RequestFormTypeID,
          RFPermissionID: data.RFPermissionID || 0,
          FacilityID: data.FacilityID || 0,
          ActiveStatus: data.ActiveStatus || 0,
          FormView: data.FormView || 0,
          FormRespond: data.FormRespond || 0,
        };
      }),
    };
    // Dispatch to set management user data only after data dependencies are ready
    dispatch(managementUserAction.setmanagementUserData(params));
  };

  const handleClickPostalMail = (facilityID, isChecked) => {
    // Update the PostalMailGrid
    const updatedPsotalMailGrid = PostalMailGrid.map((facility) => {
      // Check if the current facilityID matches the one being updated
      if (facility.FacilityID === facilityID) {
        return {
          ...facility, // Keep the rest of the facility data unchanged
          IsActive: isChecked ? 1 : 0, // Update IsActive based on whether the checkbox is checked or not
        };
      }
      return facility; // Return the facility unchanged if it's not the one being updated
    });

    // Dispatch the updated grid data to the store
    dispatch(managementUserAction.setPostalMailGrid(updatedPsotalMailGrid));

    // Update the userInfo object
    let updatedUserInfo = { ...userInfo };

    // Update the specific facility's isActive value in type_PostalMailAccessibleFacility
    updatedUserInfo.type_PostalMailAccessibleFacility =
      updatedUserInfo.type_PostalMailAccessibleFacility.map((facility) => {
        // Check if the current facilityID matches the one being updated
        if (facility.facilityID === facilityID) {
          return {
            ...facility, // Keep the rest of the facility data unchanged
            isActive: isChecked ? 1 : 0, // Update isActive based on whether the checkbox is checked or not
          };
        }
        return facility; // Return the facility unchanged if it's not the one being updated
      });

    // Dispatch the action to update the Redux store with the updated userInfo
    dispatch(managementUserAction.setmanagementUserData(updatedUserInfo));
  };

  if (isLoading) {
    return <CustomLoader />;
  }

  return (
    managementUserData.UserRoleID !== 0 &&
    managementUserData.UserRoleID !== 10 &&
    managementUserData.UserRoleID !== 11 && (
      <div className=" managementUser d-flex flex-wrap flex-column justify-content-center  position-relative">
        <div className="admin-checkbox-style">
          <h3 className="inner-header-bg text-color mb-4 text-color">
            <i className="fas fa-shield-alt me-2"></i>{" "}
            {{
              2: "Facility Admin",
              3: "Facility Staff",
              12: "Facility Super Admin",
              13: "Facility Staff SAO",
              6: "Investigators Staff",
            }[userInfo?.UserRoleID] || ""}{" "}
            Menu Access Permission
          </h3>
          <form>
            <div className="row">
              {filteredMenuList.map((menu, index) => {
                if (
                  menu.MenuName === "Connection Requests" &&
                  facilityInfodata?.IsApprovalRequiredForConnectionRequest === 0
                ) {
                  return null; // Skip rendering this item
                }
                return (
                  <div key={index} className="col-md-12">
                    <div className="form-floating d-flex gap-0 flex-wrap radio-group-container border-bottom-1 pd--15 bg-gray-light">
                      <div className="fw-bold radio-group-label maintance-label col-md-3 font-size-16 ms-0">
                        {menu.MenuName.replace(/([A-Z])/g, " $1").trim()}
                      </div>
                      <div className="fw-bold radio-group-label col-md-3">
                        <div className="pl-5">
                          {" "}
                          <RadioButtonGroup
                            name={menu.MenuName}
                            label="" // Leave empty as label is shown outside
                            id={menu.MenuName}
                            selectedValue={menu.MenuActiveStatus}
                            handleChange={(e) =>
                              handleSelectMenuChange(
                                parseInt(e.target.value),
                                menu.MenuName,
                                menu.ManagementMenuID
                              )
                            }
                            options={AccessPermissionRadio}
                            disabled={false}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Staff Request Table directly under the radio buttons, aligned with the rest */}
                    {menu.MenuActiveStatus === 1 && (
                      <>
                        {menu.MenuName === "Staff Requests" && (
                          <div className="row access-showing-grid">
                            <div className="col-md-3"></div>
                            <div className="col-md-9 d-flex flex-wrap justify-content-start mt-2">
                              <div
                                style={{
                                  overflowY: "auto",
                                  maxHeight: "300px",
                                  width: "100%",
                                }}
                              >
                                <Table
                                  title=""
                                  columns={RFcolumns}
                                  data={managementUserData.UserRoleID == 6 ? RequestForm?.filter((x) => x?.RequestFormTypeID != 61) : RequestForm}
                                  style={{
                                    overflowX: "auto",
                                  }}
                                  options={{
                                    rowStyle: {
                                      padding: "0px",
                                    },
                                    cellStyle: {
                                      padding: "0px",
                                    },
                                  }}
                                />
                                <div
                                  style={{
                                    backgroundColor: "#666",
                                    color: "white",
                                    padding: "4px",
                                    textAlign: "left",
                                  }}
                                >
                                  Total No of Records: {managementUserData.UserRoleID == 6 ? RequestForm?.filter((x) => x?.RequestFormTypeID != 61)?.length : RequestForm?.length}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {menu.subMenu && (
                          <div className="row ms-0">
                            <div className="col-md-3"></div>
                            {/* Placeholder column for alignment */}
                            <div className="col-md-9  ">
                              <div className="d-flex flex-wrap gap-3-5 flex-wrap admin-checkbox-style pb-10 pt-10">
                                {menu.subMenu.map((subMenu, subIndex) => {
                                  // Condition for "Legal Mail" to restrict display based on UserRoleID
                                  if (
                                    subMenu.SubMenuName === "Legal Mail" &&
                                    (managementUserData.UserRoleID === 2 ||
                                      managementUserData.UserRoleID === 13 ||
                                      managementUserData.UserRoleID === 6)
                                  ) {
                                    return null; // Skip rendering this item
                                  }

                                  if (
                                    subMenu.SubMenuId === "InmatesModify" &&
                                    managementUserData.UserRoleID === 13
                                  ) {
                                    return null; // Skip rendering this item
                                  }

                                  // Render other submenus and "Legal Mail" if role conditions are met
                                  return (
                                    <div
                                      key={subIndex}
                                      className="form-check min-width-90 mb-0"
                                    >
                                      <CheckBoxInput
                                        label={subMenu.SubMenuName.replace(
                                          /([A-Z])/g,
                                          " $1"
                                        ).trim()}
                                        id={subMenu.SubMenuId}
                                        name={subMenu.SubMenuName}
                                        checked={
                                          subMenu.SubMenuActiveStatus === 1
                                        }
                                        handleClick={(e) =>
                                          handleCheckboxChange(
                                            e.target.checked,
                                            subMenu.SubMenuName,
                                            menu.ManagementMenuID,
                                            subMenu.SubManagementMenuID
                                          )
                                        }
                                        value={subMenu.SubMenuActiveStatus}
                                        disabled={false}
                                      />
                                    </div>
                                  );
                                })}
                              </div>

                              {menu.MenuName === "Postal Mails" && (
                                <div
                                  className="mb-2"
                                  style={{
                                    flex: "1 1 auto",
                                    minWidth: "300px",
                                  }}
                                >
                                  <Table
                                    title=""
                                    columns={columns}
                                    data={PostalMailGrid}
                                    className="table table-sm"
                                  />
                                  <div
                                    style={{
                                      backgroundColor: "#666",
                                      color: "white",
                                      padding: "4px",
                                      textAlign: "left",
                                    }}
                                  >
                                    Total No of Records: {PostalMailGrid.length}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </form>
        </div>
      </div>
    )
  );
});

export default React.memo(FacilityAdminMenuAccess);
